export default __webpack_public_path__ + "static/media/about_2.72cf6270.png";